import {FORM_ERROR} from 'final-form';

export const ROOT = document.getElementById('root');

export const {
    HJ_ENV: ENV,
    API_HOST,
    SEGMENT_KEY,
    SENTRY_DSN
} = (window as any).__RUNTIME_CONFIG__ || {};

export const ENVS = {
    prod: 'hj01-prod',
    stage: 'hj01-stage',
    mainDev: 'hj01-dev'
};
export const IS_PROD_ENV = ENV === ENVS.prod;
export const MULTI_ENV_PREFIX = window.location.hostname.match(/hj[0-9]{2}-(dev|stage)/)?.[0] || '';

export const API_DOMAIN = `https://${API_HOST || `broker-portal-api.${MULTI_ENV_PREFIX || 'hj01-dev'}.hjoy.net`}`;

// HTTP Status Codes
export const HTTP_CODE_OK = 200;
export const HTTP_CODE_UNAUTHORIZED = 401;
export const HTTP_CODE_NOT_FOUND = 404;
export const HTTP_CODE_TOO_MANY_REQUESTS = 429;
export const HTTP_CODE_INTERNAL_SERVER_ERROR = 500;

// Routes
export const ROUTES = {
    root: '/',
    benefitsAnalysis: '/benefits-analysis',
    clientManagement: '/client-management',
    pageNotFound: '/error/page-not-found',
    serverError: '/error/server-error'
};

export const DASHBOARD_URL = IS_PROD_ENV
    ? 'https://dashboard.healthjoy.com/'
    : `https://dashboard-fe.${ENV || MULTI_ENV_PREFIX || 'hj01-dev'}.hjoy.net`;

// Form
export const FORM_GLOBAL_ERROR = FORM_ERROR;

export const DEFAULT_TOAST_VISIBILITY_TIME = 5000;

// Validation RegExps
export const EMAIL_REGEXP = /^[a-zA-Z0-9_!.#$%&'*+\-/=?^`{|}~]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/;
export const PHONE_NUMBER_REGEXP = /\([0-9]{3}\)\s[0-9]{3}[-\s.][0-9]{4}$/;
export const ZIP_REGEXP = /^[0-9]{5}$/g;

// Support
export const DEFAULT_CONCIERGE_PHONE_NUMBER = '(877) 500-3212';
export const SUPPORT_EMAIL = 'support@healthjoy.com';

export const CONSENT_TYPES = {
    termsAndConditions: 'benefits_studio_terms_of_use'
};
